import Api from '@/api/index';
import shared_address_default from '../../../../store/shared/DefaultAddress'
import shared_bank_account_default from '@/_backoffice/_registrations/store/shared/DefaultBankAccount.js'
import shared_contact_default from '../../../../store/shared/DefaultContact'

const Driver = {
  namespaced: true,
  state: {
    default_contact: {
      ...shared_contact_default
    },

    default_address: {
      ...shared_address_default
    },

    default_bank_account: {
      ...shared_bank_account_default
    },

    one_driver: {
      name: null,
      cpf: '',
      cnh: '',

      contacts: [
        {
          ...shared_contact_default
        },
      ],

      address: {
        ...shared_address_default
      },

      bank_accounts: [
        {
          ...shared_bank_account_default
        },
      ],
    },

    all_drivers: []
  },
  getters: {
    getOneDriver: state => {
      return state.one_driver
    }
  },

  mutations: {
    clearOneDriver(state){
      state.one_driver = {...state.one_driver, ...shared_address_default, name: null, cpf: '', cnh: '', id: null}
    },

    setAllDrivers(state, data){
      state.all_drivers = [...data]
    },

    addNewContact(state) {
      state.one_driver.contacts.push({...state.default_contact})
    },

    removeContact(state, idx) {
      if (idx){
        state.one_driver.contacts.splice(idx, 1)
      }else{
        state.one_driver.contacts.pop()
      }
    },

    addNewBankAccount(state) {
      state.one_driver.bank_accounts.push({...state.default_bank_account})
    },

    removeBankAccount(state) {
      state.one_driver.bank_accounts.pop()
    },

    addToAllDrivers(state, driver) {
      state.all_drivers.push({...driver})
      state.one_driver = {
        name: null,
        cpf: '',
        cnh: '',

        contacts: [
          {...state.default_contact}
        ],
        address: {
          ...state.default_address
        },
        bank_accounts: [
          {...state.default_bank_account}
        ],
      }
    },

    setOneDriver(state, driver) {
      state.one_driver = {...state.one_driver, ...driver}
    },

    setDriverAddress(state, address){
      state.one_driver.address = {...address}
    },
    setDriverContacts(state, contacts){
      state.one_driver.contacts = [...contacts]
    },

    setDriverBankAccounts(state, bank_accounts) {
      state.one_driver.bank_accounts = [...bank_accounts]
    },

    updateOneDriverMainData(state, main_data) {
      state.one_driver.name = main_data.name
      state.one_driver.cpf = main_data.cpf
      state.one_driver.cnh = main_data.cnh
    },

    updateOneDriverAddress(state, address) {
      state.one_driver.address = {...address}
    },

    updateOneDriverContact(state, {contact, contact_idx}) {
      //podendo ser usado também o vue.set
      state.one_driver.contacts.splice(contact_idx, 1, {...contact})
    },

    updateOneDriverBankAccount(state, {bank_account, bank_account_idx}) {
      //podendo ser usado também o vue.set
      state.one_driver.bank_accounts.splice(bank_account_idx, 1, {...bank_account})
    }
  },

  actions: {
    clearOneDriver({commit}){
      commit('clearOneDriver')
    },
    addDriverContact(context){
      context.commit('addNewContact')
    },

    deleteDriverContact(context, {contact, contact_idx}){
      if (contact.id){
        Api.Contact.delete(contact.id).then(()=>{
          context.commit('removeContact', contact_idx)
        }).catch(error=>{
          console.log(error);
        })
      } else {
        context.commit('removeContact', null)
      }
    },

    addDriverBankAccount(context){
      context.commit('addNewBankAccount')
    },

    deleteDriverBankAccount(context){
      context.commit('removeBankAccount')
    },

    saveMainData(context, {main_data, id}) {
      context.dispatch('update', {data: main_data}).then( () => {
        context.commit('updateOneDriverMainData', main_data)
      })
    },

    saveAddress(context, {address}) {
      return Api.Address.update(address).then(() => {
        context.commit('updateOneDriverAddress', address)
        return true
      }).catch(error => {
        console.log(error);
      })
    },

    saveContact(context, {contact, contact_idx}) {
      const ACTION = contact.id? 'update' : 'create'
      return Api.Contact[ACTION](contact).then(r=> r.data).then(cont => {
        cont = cont.data? cont.data.attributes : cont
        context.commit('updateOneDriverContact', {contact: cont, contact_idx})
        return true
      }).catch(error => {
        console.log(error);
      })
    },

    saveBankAccount(context, {bank_account, bank_account_idx}) {
      const ACTION = bank_account.id? 'update' : 'create'
      return Api.BankAccount[ACTION](bank_account).then(r=> r.data).then(bkacc => {
        bkacc = bkacc.data? bkacc.data.attributes : bkacc
        context.commit('updateOneDriverBankAccount', {bank_account: bkacc, bank_account_idx})
        return true
      }).catch(error => {
        console.log(error);
      })
    },

    update(context, {data}) {
      data = data? data : context.state.one_driver
      Api.Driver.update({...data})
        .then(r => r.data)
        .then(r => {
          return true
        }).catch(error => {
          console.log(error)
        })
    },

    index(context) {
      context.state.all_drivers = []
      return Api.Driver.index()
        .then(r => r.data)
        .then(r => {
          r = r.data? r.data.map(d=>d.attributes) : r
          context.commit('setAllDrivers', r)
          return r
        }).catch(error => {
          console.log(error)
        })
    },

    createDriver(context) {
      return Api.Driver.create(context.state.one_driver)
        .then(r => r.data)
        .then(r => {
          context.commit('addToAllDrivers', r)
          return r
        }).catch(error => {
          console.log(error)
        })
    },

    showOneDriver(context, id) {
      Api.Driver.show(id)
        .then(r => r.data)
        .then(r => {
          context.commit('setOneDriver', r)
        }).catch(error => {
          console.log(error)
        })
    }
  }

};

export default Driver;
